let _ = t => t,
  _t;
import { memo, useContext } from 'react';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { LEFT_COL_WIDTH, RIGHT_COL_WIDTH } from '../../constants/MediaTimelinePositioning';
import styledWithTheme from 'foundations-theming/utils';
import { MediaBufferProgress } from './MediaBufferProgress';
import { MediaBufferWaitingIndicator } from './MediaBufferWaitingIndicator';
import { ADVANCED } from '../../../types/MediaTimelineTypes';
import { MediaPlayerProgressIndicator } from './MediaPlayerProgressIndicator';
import { MediaPlayerCurrentTime } from './MediaPlayerCurrentTime';
import { MediaPlayerTime } from './MediaPlayerTime';
import { MEDIA_PLAYER_COLORS } from '../../constants/Colors';
import { MediaPlayerBar } from './MediaPlayerBar';
import MediaTimelineClipHighlight from './MediaTimelineClipHighlight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMediaProgressBarWrapper = styledWithTheme.div(_t || (_t = _`
  position: absolute;
  inset: 0;
  user-select: none;
`));
const MediaProgressBar = ({
  variant,
  isMediaTimelineExpanded,
  transcriptUtterances
}) => {
  const {
    preciseDuration
  } = useContext(MediaPlaybackControlsContext);
  return /*#__PURE__*/_jsx(StyledMediaProgressBarWrapper, {
    children: /*#__PURE__*/_jsxs(Flex, {
      blockSize: "100%",
      "data-test-id": "mediaTimeline-progressBar",
      children: [/*#__PURE__*/_jsx(Box, {
        "data-test-id": "mediaProgressBar-progressCurrentTime",
        basis: LEFT_COL_WIDTH,
        shrink: 0,
        grow: 0,
        children: /*#__PURE__*/_jsx(MediaPlayerCurrentTime, {})
      }), /*#__PURE__*/_jsxs(Box, {
        grow: 1,
        position: "relative",
        children: [variant === ADVANCED && /*#__PURE__*/_jsx(MediaTimelineClipHighlight, {}), /*#__PURE__*/_jsx(MediaPlayerBar, {
          backgroundColor: MEDIA_PLAYER_COLORS.DEFAULT_STATUS_FILL,
          inlineSize: "100%"
        }), /*#__PURE__*/_jsx(MediaBufferProgress, {}), /*#__PURE__*/_jsx(MediaPlayerProgressIndicator, {
          showPlayerHead: !!(variant === ADVANCED && isMediaTimelineExpanded && transcriptUtterances && transcriptUtterances.length !== 0)
        }), /*#__PURE__*/_jsx(MediaBufferWaitingIndicator, {})]
      }), /*#__PURE__*/_jsx(Box, {
        "data-test-id": "mediaProgressBar-duration",
        basis: RIGHT_COL_WIDTH,
        shrink: 0,
        grow: 0,
        children: /*#__PURE__*/_jsx(MediaPlayerTime, {
          time: preciseDuration,
          textAlign: "end"
        })
      })]
    })
  });
};
export default /*#__PURE__*/memo(MediaProgressBar);